import { useParams } from 'react-router';
import { resolveEffectiveClientId, useEffectiveAccess } from '@/lib/effectiveAccess';

export function useClientId(): string {
  const { clientId: routeClientId } = useParams<{ clientId: string }>();
  const { user, isSimulating, simulatedGln } = useEffectiveAccess();
  return resolveEffectiveClientId(routeClientId, user, isSimulating, simulatedGln);
}
